// 电子说明书管理
import http from "@/jslibs/axios/http";

// 列表
export const page = (data) => http.post("/web/contentManager/getElectronicInstructionList", data);

// 新增
export const add = (data) => http.post("/web/contentManager/addElectronicInstruction", data);

// 删除
export const del = (data) => http.post("/web/contentManager/deleteElectronicInstruction", data);

// 详情
export const detail = (data) => http.post("/web/contentManager/getElectronicInstructionDetail", data);

// 编辑 
export const edit = (data) => http.post("/web/contentManager/updateElectronicInstruction", data);